<mat-toolbar *ngIf="(runningInPortal$ | async) === false && (runningInIFrame$ | async) === false">
  <span class="standalone-toolbar-spacer"></span>
  <button mat-icon-button tabindex="-1" (click)="doLogout()">
    <mat-icon>logout</mat-icon>
  </button>
</mat-toolbar>

<div class="content-outlet">
  <router-outlet></router-outlet>
</div>
